<template>
  <div class="terms-dialog" style="padding: 20px;">
    <div v-if="!$vlastMode && $userIsClient">
      <h3>Before sending messages to your sports {{ $starLabel }}, please accept our <a :href="bookingTncLink()" target="_blank">terms and conditions</a></h3>
      <ul>
        <li>You must only communicate with the sports {{ $starLabel }} via the {{ this.clientName }} messaging portal. You can share files within the portal, but our system filters out phone numbers and emails.</li>
        <li>You must not ask the sports {{ $starLabel }} to do anything that is not included in your booking. If any changes need to be made to your booking (e.g. dates, deliverables etc.), you must notify the {{ this.clientName }} team</li>
        <li>To avoid confusion, please keep your messages focused on important matters relating to your request only</li>
      </ul>
    </div>
    <div v-if="!$vlastMode && ($userIsTalent || $userIsManager)">
      <h3>Before messaging the client, here's a few important things to remember:</h3>
      <ul>
        <li>You must only communicate with the client via the {{ clientName }} messaging portal. You can share files within the portal, but our system filters out phone numbers and emails. This helps us manage the request and protect your interests.</li>
        <li>If the client asks you to do anything that is not included in the booking, please contact the {{ clientName }} team</li>
        <li>Please respond as promptly as you can</li>
        <li>Keep the discussion focused on the details of your request</li>
        <li>If you're unsure of anything, call the {{ clientName }} team on <a href="tel:1300657601" @click="trackCallClick">1300 657 601</a></li>
      </ul>
    </div>
    <ladda-button :click="handleAcceptTermsCallback" class="btn btn-info btn-sm m-t-sm" v-html="$vlastMode ? `Get Started` : `Accept Terms`"></ladda-button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { ChatTracker } from 'mixins/analytics'
import BookingTnc from 'mixins/tnc'

export default {
  mixins: [ChatTracker, BookingTnc],
  computed: {
    ...mapState('message', ['thread']),
    booking () {
      return this.thread.booking
    }
  },
  methods: {
    ...mapActions('message', ['acceptTerms']),

    handleAcceptTermsCallback () {
      return this.acceptTerms({threadId: this.thread.id})
    },
    trackCallClick () {
      this.trackEvent(this.analytics.V2.ChatCallClickEvent)
    }
  }
}
</script>
